import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nProvider";

const EDITORIAL_IMG = "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};
const item = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

export function Editorial() {
  const { t } = useI18n();

  return (
    <section className="relative py-20 lg:py-32" data-testid="editorial-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <motion.div
            className="lg:col-span-5 lg:sticky lg:top-24 self-start"
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            variants={container}
          >
            <motion.div variants={item} className="flex items-center gap-3">
              <span className="h-px w-8 bg-emerald-500" />
              <p className="eyebrow">{t("editorial.eyebrow")}</p>
            </motion.div>
            <motion.h2 variants={item} className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05] text-balance">
              {t("editorial.heading")}
            </motion.h2>

            <motion.div variants={item} className="mt-8 photo-clip overflow-hidden">
              <div className="relative aspect-[4/5] w-full">
                <img
                  src={EDITORIAL_IMG}
                  alt={t("editorial.image_alt")}
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                  data-testid="editorial-image"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B132B]/80 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 p-5 text-xs font-mono text-slate-300 tracking-widest uppercase">
                  Puerto Madero · Recoleta · Palermo
                </div>
              </div>
            </motion.div>
          </motion.div>

          <motion.div
            className="lg:col-span-7 space-y-6"
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.15 }}
            variants={container}
          >
            {["p1", "p2", "p3", "p4"].map((k) => (
              <motion.p
                key={k}
                variants={item}
                className="text-base sm:text-lg text-slate-300 leading-relaxed"
              >
                {t(`editorial.${k}`)}
              </motion.p>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default Editorial;
